import { render, staticRenderFns } from "./OurOfferTabs.vue?vue&type=template&id=56efcd60&scoped=true&"
import script from "./OurOfferTabs.vue?vue&type=script&lang=js&"
export * from "./OurOfferTabs.vue?vue&type=script&lang=js&"
import style0 from "./OurOfferTabs.vue?vue&type=style&index=0&id=56efcd60&lang=scss&scoped=true&"
import style1 from "./OurOfferTabs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56efcd60",
  null
  
)

export default component.exports